import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const fleetData = [{
  name: "Skid Steer Loader",
  model: "2 Speed Skid Steer",
  rates: {
    hourly: "$90",
    weekly: "$3,000",
    monthly: "$10,080"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/skid_steer_bobcat_s76.png",
  alt: "White Bobcat S76 skid steer loader on industrial site"
}, {
  name: "Track Loader",
  model: "Compact Track Loader",
  rates: {
    hourly: "$90",
    weekly: "$3,000",
    monthly: "$10,080"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/track_loader_kubota_svl75.png",
  alt: "Orange Kubota compact track loader side view"
}, {
  name: "Compact Backhoe",
  model: "4x4 Backhoe Loader",
  rates: {
    hourly: "$160",
    weekly: "$4,800",
    monthly: "$14,400"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/backhoe_loader_4x4_precision.png",
  alt: "Heavy duty 4x4 backhoe loader on construction site"
}, {
  name: "3.5 Ton Mini Excavator",
  model: "3.5 Ton Mini Excavator",
  rates: {
    hourly: "$95",
    weekly: "$3,200",
    monthly: "$10,880"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/excavator_3_5_ton.png",
  alt: "3.5 Ton mini excavator on construction site"
}, {
  name: "Compact Loader",
  model: "Wheel Loader",
  rates: {
    hourly: "$350",
    weekly: "$1,750",
    monthly: "$5,250"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/wheel_loader_case_221f.png",
  alt: "Tan Case compact wheel loader bucket down"
}, {
  name: "Telehandler",
  model: "Telescopic Handler",
  rates: {
    hourly: "$425",
    weekly: "$2,125",
    monthly: "$6,375"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/telehandler_jlg_g5.png",
  alt: "Orange JLG telehandler with raised forks"
}, {
  name: "Trench Roller",
  model: "Trench Roller",
  rates: {
    hourly: "$185",
    weekly: "$925",
    monthly: "$2,775"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/roller_wacker_neuson_rtx.png",
  alt: "Yellow Wacker Neuson trench roller on dirt"
}, {
  name: "Dump Truck",
  model: "Articulated Dump Truck",
  rates: {
    hourly: "$485",
    weekly: "$2,425",
    monthly: "$7,275"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/dump_truck_hydrema_707g.png",
  alt: "Blue Hydrema articulated compact dump truck"
}];
export default function EliteFleetGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="16726" id="precision-fleet-inventory" ref={ref} className={cn("w-full py-16 bg-background text-foreground transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="text-3xl md:text-5xl font-sans font-black text-secondary mb-2 tracking-tighter uppercase">
            Precision Inventory
          </h2>
          <div className="h-1.5 w-16 bg-primary rounded-sm"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {fleetData.map((vehicle, i) => <Link key={i} to="/EquipmentPage" className="block group h-full" data-index={i}>
              <Card className="h-full border border-border shadow-sm hover:shadow-xl hover:border-primary/40 transition-all duration-300 bg-card overflow-hidden flex flex-col rounded-sm">
                <div className="relative h-48 w-full bg-muted/30 flex items-center justify-center p-6 overflow-hidden">
                  <img src={vehicle.image} data-wvc-srcset={`${vehicle.image}-wvc-srcset`} data-wvc-sizes={`${vehicle.image}-wvc-sizes`} alt={vehicle.alt} loading="lazy" className="w-full h-full object-contain drop-shadow-xl transition-transform duration-700 ease-out group-hover:scale-110" />
                </div>

                <CardContent className="flex flex-col items-center justify-center p-6 text-center grow">
                  <h3 className="font-sans text-xl font-bold text-secondary mb-4 tracking-tight">
                    {vehicle.model}
                  </h3>
                  <div className="mt-auto pt-4 border-t border-border/50 w-full flex flex-col gap-2">
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-sans font-bold text-muted-foreground tracking-widest uppercase">
                        Hourly
                      </span>
                      <span className="text-lg font-mono font-black text-primary">
                        {vehicle.rates.hourly}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-sans font-bold text-muted-foreground tracking-widest uppercase">
                        Weekly
                      </span>
                      <span className="text-lg font-mono font-black text-primary">
                        {vehicle.rates.weekly}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] font-sans font-bold text-muted-foreground tracking-widest uppercase">
                        Monthly
                      </span>
                      <span className="text-lg font-mono font-black text-primary">
                        {vehicle.rates.monthly}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}